export default __webpack_public_path__ + "static/media/Shrinkhala_video.b57260bf.mp4";